import { lazy } from 'react';
import { ROUTES } from '../helpers/contants';
import { routeTypes } from '../types';
import Welcome from '../Pages/Register/Welcome';
import BusinessInfo from '../Pages/Register/BusinessInfo';
import ProductManagement from '../Pages/ProductionManagement';
import StudioManagement from '../Pages/Studio';
import Order from '../Pages/Orders';
import OrderSettings from '../Pages/Dashboard/OrderSettings';
import AddCrew from '../Pages/Dashboard/OrderSettings/AddCrew';
import PreviewShiftCart from '../Pages/Cart/PreviewShiftCart';
import ViewAllProductionSets from '../Pages/Risk/components/Production/ViewAllProductionSets';
import ViewAllEpisodeSets from '../Pages/Risk/components/Episode/ViewAllEpisodeSets';

const DashboardWrapper = lazy(() => import('../Pages/Dashboard'));
const AuthLayout = lazy(() => import('../Containers/AuthLayout'));

const Financials = lazy(() => import('../Pages/Financials'));

const Chats = lazy(() => import('../Pages/Chats'));
const ProductionDetail = lazy(
  () => import('../Pages/Dashboard/production/productionDetail'),
);
const CreateSet = lazy(() => import('../Pages/Dashboard/set/createSet'));
const SetDetail = lazy(() => import('../Pages/Dashboard/set/setDetail'));
const AllRelatedSets = lazy(
  () => import('../Pages/Dashboard/components/AllRelatedSets'),
);

const EpisodeDetail = lazy(
  () => import('../Pages/Dashboard/episode/episodeDetail'),
);
const CreateLocation = lazy(
  () => import('../Pages/Dashboard/location/createLocation'),
);
const LocationDetail = lazy(
  () => import('../Pages/Dashboard/location/locationDetails'),
);
const LandingPage = lazy(() => import('../Pages/Landing'));
const EpisodeMamagement = lazy(() => import('../Pages/EpisodeMamagement'));
const PublicPages = lazy(() => import('../Pages/PublicPage'));
const Profile = lazy(() => import('../Pages/Profile'));
// const Commissions = lazy(() => import('../Pages/CommissionsManagement'))
const ProfileSetup = lazy(() => import('../Pages/ProfileSetup'));

const GetSupport = lazy(() => import('../Pages/PublicPage/GetSupport'));
const AddContact = lazy(() => import('../Components/AddContactCrew'));
const RiskCenter = lazy(() => import('../Pages/RiskCenter'));
const Events = lazy(() => import('../Pages/RiskCenter/Events'));
const Orders = lazy(() => import('../Pages/Dashboard/Orders'));
const shiftDetail = lazy(() => import('../Pages/ShiftDetail/ShiftDetail'));

const productionDashboard = lazy(() => import('../Pages/Dashboard/production'));
const epsiodeDashboard = lazy(() => import('../Pages/Dashboard/episode'));
const setDashboard = lazy(() => import('../Pages/Dashboard/set'));
const locationDashboard = lazy(() => import('../Pages/Dashboard/location'));

const ActiveSets = lazy(
  () => import('../Pages/Dashboard/production/activeSets'),
);
const ActiveOrders = lazy(
  () => import('../Pages/Dashboard/production/activeOrders'),
);
const ActiveDocuments = lazy(
  () => import('../Pages/Dashboard/production/activeDocuments'),
);
const RequestToJoin = lazy(
  () => import('../Pages/Dashboard/production/requestToJoin'),
);
const CrewMembers = lazy(
  () => import('../Pages/Dashboard/production/crewMembers'),
);

const SearchComponent = lazy(() => import('../Pages/Search'));
const TotalProductions = lazy(
  () => import('../Pages/Dashboard/studio/Components/TotalProductions'),
);

const TotalEpisodes = lazy(
  () => import('../Pages/Dashboard/studio/Components/totalEpisode'),
);
const TotalSets = lazy(
  () => import('../Pages/Dashboard/studio/Components/TotalSets'),
);
const TotalLocations = lazy(
  () => import('../Pages/Dashboard/studio/Components/TotalLocations'),
);
const TotalProductionEpisodes = lazy(
  () => import('../Pages/Dashboard/production/TotalProductionEpisode'),
);

const TotalLocationsSets = lazy(
  () => import('../Pages/Dashboard/set/TotalLocationsSet'),
);
const ActiveLocationSet = lazy(
  () => import('../Pages/Dashboard/location/ActiveSet'),
);

const AllEpisodeSet = lazy(
  () => import('../Pages/Dashboard/components/AllEpisodeSet'),
);
const AllOrders = lazy(() => import('../Pages/Dashboard/components/AllOrders'));
const AllOrdersDepartment = lazy(
  () => import('../Pages/Department/components/AllOrdersDept'),
);
const AllDocuments = lazy(
  () => import('../Pages/Dashboard/components/AllDocuments'),
);
const AllContactCrew = lazy(
  () => import('../Pages/Dashboard/components/AllContactCrew'),
);
const AllEpisodeSetEpisodes = lazy(
  () => import('../Pages/Dashboard/components/AllEpisodeSetDetail'),
);
const AllDepartment = lazy(
  () => import('../Pages/Dashboard/components/AllDepartment'),
);
const ManageDepartment = lazy(
  () => import('../Pages/Dashboard/components/ManageDepartment'),
);
const MyLocations = lazy(() => import('../Pages/MyLocations'));
const MySets = lazy(() => import('../Pages/MySet'));
const DepartmentDetail = lazy(
  () => import('../Pages/Department/DepartmentDetail'),
);
const ManageEpisodeSetDepartment = lazy(
  () => import('../Pages/Department/components/ManageEpisodeSet'),
);
const ManageContactsDept = lazy(
  () => import('../Pages/Department/components/ManageContacts'),
);
const Explore = lazy(() => import('../Pages/Explore'));
const StudioDashboard = lazy(
  () => import('../Pages/Dashboard/studio/Dashboard'),
);
const ViewAccess = lazy(() => import('../Pages/Profile/ViewAccess'));
const ViewAll = lazy(() => import('../Pages/Profile/ViewAll'));
const Store = lazy(() => import('../Pages/Store'));
const ChangeDepartment = lazy(() => import('../Pages/Store/ChangeDepartment'));
const AssosiatedList = lazy(() => import('../Pages/Profile/AssosiatedList'));
const AllDocDept = lazy(
  () => import('../Pages/Department/components/AllDocumentsDepartment'),
);

const Schedular = lazy(() => import('../Pages/Schedular'));
const ManageLocation = lazy(
  () => import('../Pages/Dashboard/location/ManageLocation'),
);
const ManageEpisode = lazy(
  () => import('../Pages/Dashboard/episode/ManageEpisode'),
);
const ManageProduction = lazy(
  () => import('../Pages/Dashboard/production/ManageProduction'),
);
const MyDocument = lazy(() => import('../Pages/MyDocument'));
const Spendings = lazy(() => import('../Pages/Spendings'));
const AllProductions = lazy(
  () => import('../Pages/Dashboard/studio/Components/ViewAllProductions'),
);
const ViewAllEpisodeSet = lazy(
  () => import('../Pages/Dashboard/production/Components/ViewAllEpisodeSet'),
);
const ViewAllSet = lazy(
  () => import('../Pages/Dashboard/episode/Components/ViewAllSet'),
);
const ViewAllSetLocation = lazy(
  () => import('../Pages/Dashboard/location/Components/ViewAllSet'),
);

const StudioDetail = lazy(() => import('../Pages/Studio/StudioDetail'));
const ViewAllStudioProd = lazy(
  () => import('../Pages/Studio/ViewAllProductions'),
);
const ViewAllStudioOrders = lazy(() => import('../Pages/Studio/ViewAllOrders'));
const ViewAllStudioDocuments = lazy(
  () => import('../Pages/Studio/ViewAllDocuments'),
);
const StartOrder = lazy(() => import('../Pages/Orders/StartOrder'));
const OrderDetail = lazy(() => import('../Pages/MyOrders/OrderDetails'));
const PreviewShift = lazy(() => import('../Pages/Orders/PreviewShift'));
const addMoreItems = lazy(() => import('../Pages/Cart/AddMoreItems'));
const MyOrders = lazy(() => import('../Pages/MyOrders'));
const AddToOrder = lazy(() => import('../Pages/Cart/AddMoreItems/AddToOrder'));
const MyOrderAddToOrder = lazy(
  () => import('../Pages/MyOrders/AddMoreItems/AddToOrder'),
);
const myOrderAddMoreItems = lazy(
  () => import('../Pages/MyOrders/AddMoreItems'),
);
const Finance = lazy(() => import('../Pages/Finance'));
const VendorSearch = lazy(() => import('../Pages/Store/vendorSearch'));
const InvoiceDetail = lazy(
  () => import('../Pages/MyOrders/Invoice/OrderInvoiceDetail'),
);
const Invoices = lazy(() => import('../Pages/Invoices'));
const PaymentHistory = lazy(() => import('../Pages/PaymentHistory'));
const Deeplink = lazy(() => import('../Pages/Deeplink'));
const ReturnReuest = lazy(() => import('../Pages/ReturnRequest'));
const Payments = lazy(() => import('../Pages/Payments'));
const Risk = lazy(() => import('../Pages/Risk'));
const ThreatDetail = lazy(
  () => import('../Pages/Risk/components/ThreatDetail'),
);
const AddThreat = lazy(() => import('../Pages/Risk/components/AddThreat'));
const ViewAllStudioProductions = lazy(
  () => import('../Pages/Risk/components/Studio/ViewAllStudioProductions'),
);
const AddContactStudio = lazy(
  () => import('../Pages/Studio/AddContactsStudio'),
);
const AllContactStudio = lazy(() => import('../Pages/Studio/AllContactCrew'));
const LocationRiskDash = lazy(
  () => import('../Pages/Risk/components/Location/LocationDashboard'),
);
const EpisodeRiskDash = lazy(
  () => import('../Pages/Risk/components/Episode/EpisodeDashboard'),
);
const SetRiskDash = lazy(
  () => import('../Pages/Risk/components/Set/SetDashboard'),
);
const ProductionRiskDash = lazy(
  () => import('../Pages/Risk/components/Production/ProductionDashboard'),
);
const ActiveThreats = lazy(
  () => import('../Pages/Risk/components/ActiveThreats'),
);
const ManageStudio = lazy(() => import('../Pages/Studio/ManageStudio/index'));
const AddContactRolesStudio = lazy(
  () => import('../Pages/Studio/AddContact/AddContact'),
);
const BlockList = lazy(() => import('../Pages/Chats/components/BlockList'));
const AddContactRolesProduction = lazy(
  () => import('../Pages/ProductionManagement/components/AddContact'),
);
const addContactRolesEpisode = lazy(
  () => import('../Pages/EpisodeMamagement/components/AddContact'),
);
const addContactRolesSet = lazy(
  () => import('../Pages/Dashboard/set/components/AddContact'),
);
const addContactRolesLocation = lazy(
  () => import('../Pages/Dashboard/location/Components/AddContact'),
);
const addContactRolesDepartment = lazy(
  () => import('../Pages/Department/components/AddContact'),
);

const restrictedPermission = lazy(
  () => import('../Pages/Studio/AddContact/Restricted'),
);
const studioDepartmentDetail = lazy(
  () => import('../Pages/Studio/DepartmentDetail'),
);
const episodeDepartmentDetail = lazy(
  () => import('../Pages/Dashboard/episode/episodeDepartmentDetail'),
);
const setDepartmentDetail = lazy(
  () => import('../Pages/Dashboard/set/setDepartmentDetail'),
);
const locationDepartmentDetail = lazy(
  () => import('../Pages/Dashboard/location/locationDepartmentDetail'),
);

const financeViewAllOrders = lazy(
  () => import('../Pages/Spendings/Components/ViewAllOrders'),
);

const pageRoutess: routeTypes[] = [
  {
    id: 1,
    name: 'Dashboard',
    path: ROUTES.DASHBOARD,
    Component: DashboardWrapper,
    isPrivate: true,
  },
  {
    id: 2,
    name: 'Login',
    path: ROUTES.LOGIN,
    Component: AuthLayout,
    isPrivate: false,
    pageProp: { page: 'Login' },
  },
  {
    id: 3,
    name: 'SignUp',
    path: ROUTES.SIGNUP,
    Component: AuthLayout,
    isPrivate: false,
    pageProp: { page: 'SignUp' },
  },
  {
    id: 4,
    name: 'Verify',
    path: ROUTES.VERIFY,
    Component: AuthLayout,
    isPrivate: false,
    pageProp: { page: 'Verify' },
  },
  {
    id: 5,
    name: 'Forgot',
    path: ROUTES.FORGOT_PASSWORD,
    Component: AuthLayout,
    isPrivate: false,
    pageProp: { page: 'Forgot' },
  },
  {
    id: 6,
    name: 'Reset',
    path: ROUTES.RESET_PASSWORD,
    Component: AuthLayout,
    isPrivate: false,
    pageProp: { page: 'Reset' },
  },
  {
    id: 6,
    name: 'Welcome',
    path: ROUTES.WELCOME,
    Component: Welcome,
    isPrivate: true,
  },
  {
    id: 7,
    name: 'BusinessInfo',
    path: ROUTES.BUSINESSINFO,
    Component: BusinessInfo,
    isPrivate: true,
  },
  {
    id: 8,
    name: 'ProductMamagement',
    path: ROUTES.MY_PRODUCTION,
    Component: ProductManagement,
    isPrivate: true,
    pageProp: { page: 'ProductMamagement' },
  },
  {
    id: 9,
    name: 'ProductMamagement',
    path: ROUTES.CREATE_PRODUCTION,
    Component: ProductManagement,
    isPrivate: true,
    pageProp: { page: 'CreateProduction' },
  },
  {
    id: 9990,
    name: 'ProductMamagement',
    path: `${ROUTES.CREATE_PRODUCTION}/:productionId`,
    Component: ProductManagement,
    isPrivate: true,
    pageProp: { page: 'UpdateProduction' },
  },
  {
    id: 10,
    pageProp: { page: 'dashboard' },
    name: 'ProductionDetail',
    path: `${ROUTES.PRODUCTION_DETAIL}/:id`,
    Component: ProductionDetail,
    isPrivate: true,
  },
  {
    id: 11,
    pageProp: { page: 'dashboard' },
    name: 'CreateSet',
    path: `${ROUTES.CREATE_SET}`,
    Component: CreateSet,
    isPrivate: true,
  },
  {
    id: 12,
    pageProp: { page: 'dashboard' },
    name: 'SetDetail',
    path: `${ROUTES.SET_DETAIL}/:id`,
    Component: SetDetail,
    isPrivate: true,
  },
  {
    id: 13,
    pageProp: { page: 'dashboard' },
    name: 'EpisodeDetail',
    path: `${ROUTES.EPISODE_DETAIL}/:id`,
    Component: EpisodeDetail,
    isPrivate: true,
  },
  {
    id: 14,
    pageProp: { page: 'dashboard' },
    name: 'CreateLocation',
    path: `${ROUTES.CREATE_LOCATION}`,
    Component: CreateLocation,
    isPrivate: true,
  },
  {
    id: 15,
    pageProp: { page: 'dashboard' },
    name: 'LocationDetail',
    path: `${ROUTES.LOCATION_DETAIL}/:id`,
    Component: LocationDetail,
    isPrivate: true,
  },
  {
    id: 16,
    pageProp: { page: 'dashboard' },
    name: 'LocationDetail',
    path: `${ROUTES.LANDING}`,
    Component: LandingPage,
    isPrivate: false,
  },
  {
    id: 17,
    name: 'EpisodeMamagement',
    path: ROUTES.EPISODE,
    Component: EpisodeMamagement,
    isPrivate: true,
    pageProp: { page: 'EpisodeMamagement' },
  },
  {
    id: 18,
    name: 'EpisodeMamagement',
    path: ROUTES.CREATE_EPISODE,
    Component: EpisodeMamagement,
    isPrivate: true,
    pageProp: { page: 'CreateEpisode' },
  },
  {
    id: 19,
    name: 'Financials',
    path: ROUTES.FINANCIALS,
    Component: Financials,
    isPrivate: true,
    pageProp: { page: 'Financials' },
  },
  {
    id: 20,
    name: 'Profile',
    path: ROUTES.PROFILE,
    Component: Profile,
    isPrivate: true,
  },
  {
    id: 22,
    name: 'Policies',
    path: ROUTES.POLICIES,
    Component: PublicPages,
    isPrivate: false,
    pageProp: { page: 'privacyPolicy' },
  },
  {
    id: 23,
    name: 'Terms',
    path: ROUTES.TERMS,
    Component: PublicPages,
    isPrivate: false,
    pageProp: { page: 'termsAndConditions' },
  },
  {
    id: 41,
    name: 'Terms',
    path: ROUTES.FAQ,
    Component: PublicPages,
    isPrivate: false,
    pageProp: { page: 'faq' },
  },
  {
    id: 24,
    name: 'Chats',
    path: ROUTES.CHATS,
    Component: Chats,
    isPrivate: true,
    pageProp: { page: 'Chats' },
  },
  {
    id: 25,
    name: 'ProfileSetup',
    path: ROUTES.SELECT_DEPARTMENT,
    Component: ProfileSetup,
    isPrivate: true,
    pageProp: { page: 'department' },
  },
  {
    id: 26,
    name: 'ProfileSetup',
    path: ROUTES.SELECT_POSITION,
    Component: ProfileSetup,
    isPrivate: true,
    pageProp: { page: 'position' },
  },
  {
    id: 27,
    name: 'ProfileSetup',
    path: ROUTES.SELECT_PHOTO,
    Component: ProfileSetup,
    isPrivate: true,
    pageProp: { page: 'profilePhoto' },
  },
  {
    id: 28,
    name: 'AddContact',
    path: ROUTES.ADD_CONTACT,
    Component: AddContact,
    isPrivate: false,
    pageProp: { page: 'addContact' },
  },
  {
    id: 29,
    name: 'AddContactProduct',
    path: ROUTES.ADD_CONTACT_PRODUCTS,
    Component: ProductManagement,
    isPrivate: true,
    pageProp: { page: 'AddContactProduct' },
  },
  {
    id: 29,
    name: 'GetSupport',
    path: ROUTES.GET_SUPPORT,
    Component: PublicPages,
    isPrivate: false,
    pageProp: { page: 'support' },
  },

  {
    id: 30,
    name: 'RiskCenter',
    path: ROUTES.RISK,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'dashboard' },
  },

  {
    id: 31,
    name: 'RiskCenter',
    path: `${ROUTES.RISK_EVENT_DETAIL}/:id`,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'event-detail' },
  },
  {
    id: 32,
    name: 'RiskCenter',
    path: `${ROUTES.RISK_USER_DETAIL}/:id`,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'user-detail' },
  },
  {
    id: 33,
    name: 'RiskCenter',
    path: ROUTES.RISK_BOOK_SERVICE,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'book-service' },
  },
  {
    id: 34,
    name: 'RiskCenter',
    path: `${ROUTES.RISK_SERVICE_DETAIL}/:id`,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'service-detail' },
  },
  {
    id: 34,
    name: 'RiskCenter',
    path: ROUTES.RISK_CART,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'cart' },
  },
  {
    id: 35,
    name: 'RiskCenter',
    path: ROUTES.ALL_SERVICES,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'all-services' },
  },
  {
    id: 35,
    name: 'RiskCenter',
    path: `${ROUTES.BOOKING_DETAILS}/:id`,
    Component: RiskCenter,
    isPrivate: true,
    pageProp: { page: 'book-details' },
  },
  {
    id: 36,
    name: 'RiskCenter',
    path: ROUTES.EVENTS,
    Component: Events,
    isPrivate: true,
    pageProp: { page: 'book-details' },
  },
  {
    id: 37,
    name: 'Orders',
    path: ROUTES.ORDERS,
    Component: Orders,
    isPrivate: true,
  },
  {
    id: 37,
    name: 'ShiftDetail',
    path: ROUTES.shiftDetail,
    Component: shiftDetail,
    isPrivate: true,
  },
  {
    id: 38,
    name: 'ProductionDashborad',
    path: ROUTES.PRODUCTION_DASHBOARD,
    Component: productionDashboard,
    isPrivate: true,
  },
  {
    id: 39,
    name: 'LocationDashborad',
    path: ROUTES.LOCATION_DASHBOARD,
    Component: locationDashboard,
    isPrivate: true,
  },
  {
    id: 40,
    name: 'episodeDashborad',
    path: ROUTES.EPISODE_DASHBOARD,
    Component: epsiodeDashboard,
    isPrivate: true,
  },
  {
    id: 38,
    name: 'setDashborad',
    path: ROUTES.SET_DASHBOARD,
    Component: setDashboard,
    isPrivate: true,
  },
  // {
  //   id: 383345,
  //   name: 'spending',
  //   path: ROUTES.SPENDING_DASHBOARD,
  //   Component: Spending,
  //   isPrivate: true,
  // },
  {
    id: 39,
    name: 'departments',
    path: `${ROUTES.CREATE_DEPARTMENT}`,
    Component: ProductManagement,
    isPrivate: true,
    pageProp: { page: 'departments' },
  },
  {
    id: 74,
    name: 'departments',
    path: `${ROUTES.CREATE_DEPARTMENT}/:id`,
    Component: ProductManagement,
    isPrivate: true,
    pageProp: { page: 'updatedepartments' },
  },
  {
    id: 40,
    name: 'store',
    path: ROUTES.STORE,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store' },
  },
  {
    id: 41,
    name: 'store',
    path: `${ROUTES.STOREPRODUCTS}`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-products' },
  },
  {
    id: 42,
    name: 'store',
    path: `${ROUTES.STORESERVICES}`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-services' },
  },
  {
    id: 43,
    name: 'store',
    path: ROUTES.STOREFAVOURITES,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-favorites' },
  },
  {
    id: 44,
    name: 'store',
    path: ROUTES.STOREVEDNDORS,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-vendors' },
  },
  {
    id: 45,
    name: 'store',
    path: ROUTES.STOREPACKAGES,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-packages' },
  },
  {
    id: 46,
    name: 'store',
    path: `${ROUTES.VENDORDETAILS}/:id`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-vendor-details' },
  },
  {
    id: 47,
    name: 'store',
    path: `${ROUTES.PRODUCTDETAILS}/:id`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-product-details' },
  },
  {
    id: 470,
    name: 'store',
    path: `${ROUTES.ORDERS_SETTINGS}`,
    Component: OrderSettings,
    isPrivate: true,
    pageProp: { page: 'orders-settings' },
  },
  {
    id: 53,
    name: 'store',
    path: `${ROUTES.SERVICEDETAILS}/:id`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-service-details' },
  },
  {
    id: 48,
    name: 'activeSets',
    path: ROUTES.ACTIVESETS,
    Component: ActiveSets,
    isPrivate: true,
  },
  {
    id: 49,
    name: 'activeOrders',
    path: ROUTES.ACTIVEORDERS,
    Component: ActiveOrders,
    isPrivate: true,
  },
  {
    id: 50,
    name: 'activeDocuments',
    path: ROUTES.ACTIVEDOCUMENTS,
    Component: ActiveDocuments,
    isPrivate: true,
  },
  {
    id: 51,
    name: 'requestToJoin',
    path: ROUTES.REQUESTTOJOIN,
    Component: RequestToJoin,
    isPrivate: true,
  },
  {
    id: 52,
    name: 'crewMembers',
    path: ROUTES.CREWMEMBERS,
    Component: CrewMembers,
    isPrivate: true,
  },
  {
    id: 53,
    name: 'store',
    path: ROUTES.STORESEARCH,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-search' },
  },
  {
    id: 54,
    name: 'ProductionDashborad',
    path: ROUTES.SEARCH,
    Component: SearchComponent,
    isPrivate: true,
  },
  {
    id: 55,
    name: 'TotalProductions',
    // Route hardening progress: TOTAL_PRODUCTIONS name param encoding done.
    path: `${ROUTES.TOTAL_PRODUCTIONS}/:name/:id`,
    Component: TotalProductions,
    isPrivate: true,
  },
  {
    id: 56,
    name: 'TotalEpisodes',
    // Route hardening progress: TOTAL_EPISODES name param encoding done.
    path: `${ROUTES.TOTAL_EPISODES}/:name/:id`,
    Component: TotalEpisodes,
    isPrivate: true,
  },
  {
    id: 57,
    name: 'TotalLocations',
    // Route hardening progress: TOTAL_LOCATIONS name param encoding done.
    path: `${ROUTES.TOTAL_LOCATIONS}/:name/:id`,
    Component: TotalLocations,
    isPrivate: true,
  },
  {
    id: 58,
    name: 'TotalSets',
    // Route hardening progress: TOTAL_SETS name param encoding done.
    path: `${ROUTES.TOTAL_SETS}/:name/:id`,
    Component: TotalSets,
    isPrivate: true,
  },
  {
    id: 59,
    name: 'TotalLocationsSets',
    path: ROUTES.TOTAL_LOCATION_SETS,
    Component: TotalLocationsSets,
    isPrivate: true,
  },
  {
    id: 60,
    name: 'TotalProductionEpisode',
    path: ROUTES.TOTAL_PRODUCTION_EPISODE,
    Component: TotalProductionEpisodes,
    isPrivate: true,
  },
  {
    id: 61,
    name: 'ActiveLocationSet',
    // Route hardening progress: ACTIVE_LOCATION_SET name param encoding done.
    path: `${ROUTES.ACTIVE_LOCATION_SET}/:name/:id`,
    Component: ActiveLocationSet,
    isPrivate: true,
  },
  {
    id: 62,
    name: 'AllEpisodeSet',
    path: `${ROUTES.ALL_EPISODE_SET}/:type/:screen/::/:id`,
    Component: AllEpisodeSet,
    isPrivate: true,
  },
  {
    id: 63,
    name: 'AllOrders',
    path: `${ROUTES.ALL_ORDERS}/:id/:type`,
    Component: AllOrders,
    isPrivate: true,
  },
  {
    id: 64,
    name: 'AllDocuments',
    path: `${ROUTES.ALL_DOCUMENTS}/:productionId/:id/:type/:screen`,
    Component: AllDocuments,
    isPrivate: true,
  },
  {
    id: 65,
    name: 'AllContactCrew',
    path: `${ROUTES.ALL_CONTACT_CREW}/:id/:type/:entityType/:screen`,
    Component: AllContactCrew,
    isPrivate: true,
  },
  {
    id: 66,
    name: 'AllEpisodeSetEpisodes',
    path: `${ROUTES.ALL_EPISODE_SET_type}/:type/:screen/:module/:id/:productionId`,
    Component: AllEpisodeSetEpisodes,
    isPrivate: true,
  },
  {
    id: 67,
    name: 'AllDepartment',
    path: `${ROUTES.ALL_DEPARTMENT}/:module/:screen/:id/:productionId`,
    Component: AllDepartment,
    isPrivate: true,
  },
  {
    id: 68,
    name: 'ManageDepartment',
    path: `${ROUTES.MANAGE_DEPARTMENT}/:id/:type`,
    Component: ManageDepartment,
    isPrivate: true,
  },
  {
    id: 69,
    name: 'MyLocations',
    path: `${ROUTES.MY_LOCATIONS}`,
    Component: MyLocations,
    isPrivate: true,
    pageProp: { page: 'MyLocations' },
  },
  {
    id: 70,
    name: 'MySet',
    path: `${ROUTES.MY_SET}`,
    Component: MySets,
    isPrivate: true,
    pageProp: { page: 'MySets' },
  },
  {
    id: 71,
    name: 'MyEpisode',
    path: ROUTES.MY_EPISODE,
    Component: EpisodeMamagement,
    isPrivate: true,
    pageProp: { page: 'EpisodeMamagement' },
  },
  {
    id: 72,
    name: 'DepartmentDetail',
    path: `${ROUTES.DEPARTMENT_DETAIL}/:module/:id/:entityId/:productionId`,
    Component: DepartmentDetail,
    isPrivate: true,
  },
  {
    id: 73,
    name: 'AllRelatedSets',
    path: `${ROUTES.RELATED_SETS}`,
    Component: AllRelatedSets,
    isPrivate: true,
  },
  {
    id: 74,
    name: 'ManageEpisodeSetDepartment',
    // Route hardening progress: DEPARTMENT_DETAIL productionName param encoding done.
    path: `${ROUTES.DEPARTMENT_DETAIL}/:screen/:module/:type/:productionName/:id/:productionId`,
    Component: ManageEpisodeSetDepartment,
    isPrivate: true,
  },
  {
    id: 75,
    name: 'ContactsCrewDepartments',
    path: `${ROUTES.ALL_CONTACT_CREW_DEPARTMENT}/:type/:entityType/:screen/:productionId/:id`,
    Component: ManageContactsDept,
    isPrivate: true,
  },
  {
    id: 76,
    name: 'AllOrdersDept',
    path: `${ROUTES.ALL_ORDERS_DEPT}/:id/:type`,
    Component: AllOrdersDepartment,
    isPrivate: true,
  },
  {
    id: 77,
    name: 'store',
    path: `${ROUTES.PACKAGEDETAILS}/:id`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-package-details' },
  },
  {
    id: 78,
    name: 'StudioDashboard',
    path: ROUTES.STUDIO_DASHBOARD,
    Component: StudioDashboard,
    isPrivate: true,
  },
  {
    id: 79,
    name: 'ViewAccess',
    path: `${ROUTES.VIEW_ACCESS}/:id`,
    Component: ViewAccess,
    isPrivate: true,
  },
  {
    id: 80,
    name: 'ViewAllAccessedEntity',
    path: ROUTES.VIEW_ALL,
    Component: ViewAll,
    isPrivate: true,
  },
  {
    id: 81,
    name: 'GroupDetailPage',
    path: `${ROUTES.GROUP_DETAIL}/:id`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-group-details' },
  },
  {
    id: 82,
    name: 'Explore',
    path: ROUTES.EXPLORE,
    Component: Explore,
    isPrivate: true,
  },
  {
    id: 83,
    name: 'ChangeDepartment',
    path: `${ROUTES.CHANGE_DEPARTMENT}/:id`,
    Component: ChangeDepartment,
    isPrivate: true,
  },

  {
    id: 85,
    name: 'VendorProducts',
    path: ROUTES.VENDOR_PRODUCTS,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-vendor-products' },
  },
  {
    id: 86,
    name: 'VendorServices',
    path: ROUTES.VENDOR_SERVICES,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-vendor-services' },
  },
  {
    id: 87,
    name: 'VendorGroups',
    path: ROUTES.VENDOR_GROUPS,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-vendor-groups' },
  },
  {
    id: 89,
    name: 'AssosiatedList',
    path: ROUTES.ASSOSIATED_LIST,
    Component: AssosiatedList,
    isPrivate: true,
  },
  {
    id: 90,
    name: 'AllDocumentDepartment',
    path: `${ROUTES.VIEW_ALL}/:module/:id/:entityId/:productionId`,
    Component: AllDocDept,
    isPrivate: true,
  },
  //static pages
  {
    id: 91,
    name: 'GetSupport',
    path: ROUTES.CONTACT_US,
    Component: PublicPages,
    isPrivate: true,
    pageProp: { page: 'support' },
  },
  {
    id: 92,
    name: 'Policies',
    path: ROUTES.PRIVACY_POLICY,
    Component: PublicPages,
    isPrivate: true,
    pageProp: { page: 'privacyPolicy' },
  },
  {
    id: 93,
    name: 'Terms',
    path: ROUTES.TERMS_CONDITION,
    Component: PublicPages,
    isPrivate: true,
    pageProp: { page: 'termsAndConditions' },
  },
  {
    id: 94,
    name: 'Terms',
    path: ROUTES.FAQ_PAGE,
    Component: PublicPages,
    isPrivate: true,
    pageProp: { page: 'faq' },
  },
  {
    id: 95,
    name: 'Allsetepisode',
    // Route hardening progress: EPISODE_SET productionName param encoding done.
    path: `${ROUTES.EPISODE_SET}/:type/:screen/:module/:productionName/:id`,
    Component: AllEpisodeSet,
    isPrivate: true,
  },

  {
    id: 96,
    name: 'locationManageSetViewAll',
    // Route hardening progress: LOCATION productionName param encoding done.
    path: `${ROUTES.LOCATION}/:screen/:productionName/:productionId/:id`,
    Component: ManageLocation,
    isPrivate: true,
  },
  {
    id: 97,
    name: 'productionSetEpisodeManageViewAll',
    // Route hardening progress: PRODUCTION productionName param encoding done.
    path: `${ROUTES.PRODUCTION}/:type/:screen/:productionName/:productionId`,
    Component: ManageProduction,
    isPrivate: true,
  },
  {
    id: 98,
    name: 'EpisodeManageSetViewAll',
    // Route hardening progress: EPISODE productionName param encoding done.
    path: `${ROUTES.EPISODE}/:screen/:productionName/:productionId/:id`,
    Component: ManageEpisode,
    isPrivate: true,
  },
  {
    id: 99,
    name: 'MyDocument',
    path: `${ROUTES.MY_DOCUMENT}`,
    Component: MyDocument,
    isPrivate: true,
    pageProp: { page: 'my-document' },
  },

  {
    id: 40,
    name: 'spendings',
    path: `${ROUTES.SPENDINGS}/:entityType/:id`,
    Component: Spendings,
    isPrivate: true,
    pageProp: { page: 'studio' },
  },
  {
    id: 95,
    name: 'schedular',
    path: `${ROUTES.SCHEDULAR}`,
    Component: Schedular,
    isPrivate: true,
    pageProp: { page: 'schedular' },
  },
  {
    id: 100,
    name: 'UploadDocument',
    path: `${ROUTES.UPLOAD_DOCUMENT}`,
    Component: MyDocument,
    isPrivate: true,
    pageProp: { page: 'upload-Document' },
  },
  {
    id: 101,
    name: 'documentList',
    // Route hardening progress: MY_DOCUMENT name param encoding done.
    path: `${ROUTES.MY_DOCUMENT}/:name/:id`,
    Component: MyDocument,
    isPrivate: true,
    pageProp: { page: 'documentList' },
  },
  {
    id: 102,
    name: 'produtcionSpendings',
    path: `${ROUTES.PRODUCTION_SPENDINGS}/:id`,
    Component: Spendings,
    isPrivate: true,
    pageProp: { page: 'production' },
  },
  {
    id: 103,
    name: 'departmentSpendings',
    path: `${ROUTES.DEPARTMENT_SPENDINGS}/:id`,
    Component: Spendings,
    isPrivate: true,
    pageProp: { page: 'department' },
  },
  {
    id: 203,
    name: 'studioDepartmentSpendings',
    path: `${ROUTES.STUDIO_DEPARTMENT_SPENDINGS}/:studioId/:departmentId`,
    Component: Spendings,
    isPrivate: true,
    pageProp: { page: 'studioDepartment' },
  },
  {
    id: 104,
    name: 'episodeSpendings',
    path: `${ROUTES.EPISODE_SPENDINGS}/:id`,
    Component: Spendings,
    isPrivate: true,
    pageProp: { page: 'episode' },
  },
  {
    id: 105,
    name: 'setSpendings',
    path: `${ROUTES.SET_SPENDINGS}/:id`,
    Component: Spendings,
    isPrivate: true,
    pageProp: { page: 'set' },
  },
  {
    id: 106,
    name: 'locationSpendings',
    path: `${ROUTES.LOCATION_SPENDINGS}/:id`,
    Component: Spendings,
    isPrivate: true,
    pageProp: { page: 'location' },
  },
  {
    id: 107,
    name: 'ViewAllProductions',
    // Route hardening progress: VIEW_ALL_PRODUCTIONS name param encoding done.
    path: `${ROUTES.VIEW_ALL_PRODUCTIONS}/:name/:status/:id`,
    Component: AllProductions,
    isPrivate: true,
  },
  {
    id: 108,
    name: 'ViewAllEpisodeSet',
    // Route hardening progress: VIEW_ALL_EPISODE_SET name param encoding done.
    path: `${ROUTES.VIEW_ALL_EPISODE_SET}/:type/:name/:status/:id`,
    Component: ViewAllEpisodeSet,
    isPrivate: true,
  },
  {
    id: 109,
    name: 'ViewAllSet',
    // Route hardening progress: VIEW_ALL_SET name param encoding done.
    path: `${ROUTES.VIEW_ALL_SET}/:name/:status/:productionId/:id`,
    Component: ViewAllSet,
    isPrivate: true,
  },
  {
    id: 110,
    name: 'ViewAllSetLocation',
    // Route hardening progress: VIEW_ALL_SET_LOCATION name param encoding done.
    path: `${ROUTES.VIEW_ALL_SET_LOCATION}/:name/:status/:id`,
    Component: ViewAllSetLocation,
    isPrivate: true,
  },

  {
    id: 111,
    name: 'studioManagement',
    path: ROUTES.CREATE_STUDIO,
    Component: StudioManagement,
    isPrivate: true,
    pageProp: { page: 'CreateStudio' },
  },
  {
    id: 112,
    name: 'studioManagement',
    path: `${ROUTES.STUDIO_DETAIL}/:id`,
    Component: StudioDetail,
    isPrivate: true,
    pageProp: { page: 'StudioDetail' },
  },
  {
    id: 113,
    name: 'studioManagement',
    path: `${ROUTES.CREATE_STUDIO}/:id`,
    Component: StudioManagement,
    isPrivate: true,
    pageProp: { page: 'UpdateStudio' },
  },
  {
    id: 114,
    name: 'studioManagement',
    // Route hardening progress: VIEW_ALL_PROD name param encoding done.
    path: `${ROUTES.VIEW_ALL_PROD}/:name/:id`,
    Component: ViewAllStudioProd,
    isPrivate: true,
    pageProp: { page: 'UpdateStudio' },
  },
  {
    id: 115,
    name: 'studioManagement',
    // Route hardening progress: VIEW_ALL_ORDER name param encoding done.
    path: `${ROUTES.VIEW_ALL_ORDER}/:name/:id`,
    Component: ViewAllStudioOrders,
    isPrivate: true,
    pageProp: { page: 'UpdateStudio' },
  },
  {
    id: 116,
    name: 'studioManagement',
    // Route hardening progress: VIEW_ALL_DOC name param encoding done.
    path: `${ROUTES.VIEW_ALL_DOC}/:screen/:name/:id`,
    Component: ViewAllStudioDocuments,
    isPrivate: true,
    pageProp: { page: 'UpdateStudio' },
  },
  // Orders
  {
    id: 117,
    name: 'orders',
    path: `${ROUTES.START_ORDER}`,
    Component: Order,
    isPrivate: true,
    pageProp: { page: 'orders' },
  },
  {
    id: 118,
    name: 'previewShift',
    path: `${ROUTES.PREVIEW_SHIFT}`,
    Component: Order,
    isPrivate: true,
    pageProp: { page: 'preview-shift' },
  },
  {
    id: 119,
    name: 'orderDetail',
    path: `${ROUTES.ORDER_DEATIL}`,
    Component: Order,
    isPrivate: true,
    pageProp: { page: 'order-detail' },
  },
  // {
  //   id: 118,
  //   name: 'previewShift',
  //   path: `${ROUTES.PREVIEW_SHIFT}`,
  //   Component: PreviewShift,
  //   isPrivate: true,
  // },
  // {
  //   id: 119,
  //   name: 'orderDetail',
  //   path: `${ROUTES.ORDER_DEATIL}`,
  //   Component: OrderDetail,
  //   isPrivate: true,
  // },
  {
    id: 120,
    name: 'addMoreItems',
    path: `${ROUTES.ADD_MORE_ITEMS}`,
    Component: addMoreItems,
    isPrivate: true,
  },

  {
    id: 121,
    name: 'myOrders',
    path: `${ROUTES.ORDERS_LIST}`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'order-list' },
  },
  {
    id: 122,
    name: 'myOrders',
    path: `${ROUTES.ORDER_DETAILS}/:id`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'order-details' },
  },
  {
    id: 123,
    name: 'previewShift',
    path: `${ROUTES.ORDER_PREVIEW_SHIFT}/:id`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'preview-shift' },
  },
  {
    id: 124,
    name: 'orderRequest',
    path: `${ROUTES.ORDER_REQUEST}`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'order-request' },
  },
  {
    id: 124,
    name: 'vendorRequest',
    path: `${ROUTES.VENDOR_REQUEST}`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'vendor-request' },
  },
  {
    id: 125,
    name: 'addToOrders',
    path: `${ROUTES.ADD_TO_ORDER}`,
    Component: AddToOrder,
    isPrivate: true,
  },
  {
    id: 126,

    name: 'myOrderAddToOrders',
    path: `${ROUTES.MY_ORDER_ADD_TO_ORDER}`,
    Component: MyOrderAddToOrder,
    isPrivate: true,
  },

  {
    id: 127,
    name: 'myOrderAddMoreItems',
    path: `${ROUTES.MY_ORDER_ADD_MORE_ITEMS}`,
    Component: myOrderAddMoreItems,
    isPrivate: true,
  },
  {
    id: 128,
    name: 'ShiftDetailCart',
    path: ROUTES.shiftDetailCart,
    Component: PreviewShiftCart,
  },
  {
    id: 129,
    name: 'addOrderContact',
    path: `${ROUTES.ORDER_CONTACT}`,
    Component: AddCrew,
    isPrivate: true,
  },
  {
    id: 130,
    name: 'finance',
    path: `${ROUTES.FINANCE}`,
    Component: Finance,
    isPrivate: true,
  },
  {
    id: 131,
    name: 'storeVendorSearch',
    path: `${ROUTES.VENDOR_SEARCH}`,
    Component: Store,
    isPrivate: true,
    pageProp: { page: 'store-vendor-search' },
  },
  {
    id: 132,
    name: 'invoice-detail',
    path: `${ROUTES.INVOICE_DETAIL}/:id`,
    Component: Invoices,
    isPrivate: true,
    pageProp: { page: 'invoice-detail' },
  },
  {
    id: 133,
    name: 'invoice',
    path: `${ROUTES.INVOICES}`,
    Component: Invoices,
    isPrivate: true,
    pageProp: { page: 'invoice-listing' },
  },
  {
    id: 1331,
    name: 'invoice-requests',
    path: `${ROUTES.INVOICE_REQUESTS}`,
    Component: Invoices,
    isPrivate: true,
    pageProp: { page: 'invoice-requests-listing' },
  },
  {
    id: 134,
    name: 'PaymentHistory',
    path: `${ROUTES.PAYMENT_HISTORY}`,
    Component: PaymentHistory,
    isPrivate: true,
    pageProp: { page: 'payment-listing' },
  },
  {
    id: 1341,
    name: 'invoice-worksheet',
    path: `${ROUTES.WORKSHEET}/:id`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'worksheet' },
  },
  {
    id: 135,
    name: 'deep-link',
    path: `${ROUTES.DEEPLINK}/:id`,
    Component: Deeplink,
    isPrivate: false,
  },
  {
    id: 136,
    name: 'return-request-list',
    path: `${ROUTES.RETURN_REQUEST}`,
    Component: ReturnReuest,
    isPrivate: true,
    pageProp: { page: 'return-request-list' },
  },
  {
    id: 137,
    name: 'invoice-listing',
    path: `${ROUTES.INVOICE_LISTING}`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'invoice-listing' },
  },
  {
    id: 138,
    name: 'order-invoice-detail',
    path: `${ROUTES.ORDER_INVOICE_DETAIL}/:id`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'order-invoice-detail' },
  },
  {
    id: 139,
    name: 'update-shifts',
    path: `${ROUTES.UPDATE_SHIFTS}/:id`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'update-shifts' },
  },
  {
    id: 140,
    name: 'Payments',
    path: ROUTES.PAYMENT_PAGE,
    Component: Payments,
    isPrivate: true,
  },
  {
    id: 141,
    name: 'Risk',
    path: ROUTES.RISK_CENTER,
    Component: Risk,
    isPrivate: true,
    pageProp: { page: 'risk' },
  },
  {
    id: 142,
    name: 'Risk',
    path: ROUTES.ADD_THREAT,
    Component: AddThreat,
    isPrivate: true,
    pageProp: { page: 'add-threat' },
  },
  {
    id: 143,
    name: 'Risk',
    path: ROUTES.PRODUCTION_SECURITY_DASHBOARD,
    Component: ProductionRiskDash,
    isPrivate: true,
    pageProp: { page: 'production-dashboard' },
  },
  {
    id: 144,
    name: 'Risk',
    path: ROUTES.SET_SECURITY_DASHBOARD,
    Component: SetRiskDash,
    isPrivate: true,
    pageProp: { page: 'set-dashboard' },
  },
  {
    id: 145,
    name: 'Risk',
    path: ROUTES.EPIOSDE_SECURITY_DASHBOARD,
    Component: EpisodeRiskDash,
    isPrivate: true,
    pageProp: { page: 'episode-dashboard' },
  },
  {
    id: 146,
    name: 'Risk',
    path: ROUTES.LOCATION_SECURITY_DASHBOARD,
    Component: LocationRiskDash,
    isPrivate: true,
    pageProp: { page: 'location-dashboard' },
  },
  {
    id: 147,
    name: 'Risk',
    path: `${ROUTES.THREAT_DETAIL}/:id`,
    Component: ThreatDetail,
    isPrivate: true,
    pageProp: { page: 'threat-detail' },
  },
  {
    id: 168,
    name: 'Risk',
    path: ROUTES.ACTIVE_THREATS,
    Component: ActiveThreats,
    isPrivate: true,
  },
  {
    id: 148,
    name: 'Risk',
    path: `${ROUTES.VIEW_ALL_STUDIO_PRODUCTIONS}/:studioId`,
    Component: ViewAllStudioProductions,
    isPrivate: true,
  },
  {
    id: 149,
    name: 'Risk',
    path: `${ROUTES.VIEW_ALL_PRODUCTION_SETS}/:productionId`,
    Component: ViewAllProductionSets,
    isPrivate: true,
  },
  {
    id: 150,
    name: 'AddContactStudio',
    path: ROUTES.ADD_CONTACT_STUDIO,
    Component: AddContactStudio,
    isPrivate: true,
  },
  {
    id: 151,
    name: 'StudioContactCrew',
    // Route hardening progress: STUDIO_CONTACT_CREW name param encoding done.
    path: `${ROUTES.STUDIO_CONTACT_CREW}/:id/:type/:name/:screen`,
    Component: AllContactStudio,
    isPrivate: true,
  },
  {
    id: 152,
    name: 'Risk',
    path: `${ROUTES.VIEW_ALL_EPISODE_SETS}/:episodeId`,
    Component: ViewAllEpisodeSets,
    isPrivate: true,
  },
  {
    id: 153,
    name: 'myOrders',
    path: `${ROUTES.RETURN_ORDER_DETAIL}/:id`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'returned-order-details' },
  },
  {
    id: 154,
    name: 'manageStudio',
    path: `${ROUTES.MANAGE_STUDIO}/:id`,
    Component: ManageStudio,
    isPrivate: true,
  },
  {
    id: 155,
    name: 'addContactRolesStudio',
    path: `${ROUTES.ADD_CONTACT_ROLES_STUDIO}`,
    Component: AddContactRolesStudio,
    isPrivate: true,
  },
  {
    id: 156,
    name: 'blockList',
    path: `${ROUTES.BLOCKLIST}`,
    Component: BlockList,
    isPrivate: true,
  },
  {
    id: 157,
    name: 'addContactRolesProduction',
    path: `${ROUTES.ADD_CONTACT_ROLES_PRODUCTION}`,
    Component: AddContactRolesProduction,
    isPrivate: true,
  },
  {
    id: 157,
    name: 'addContactRolesEpisode',
    path: `${ROUTES.ADD_CONTACT_ROLES_EPISODE}`,
    Component: addContactRolesEpisode,
    isPrivate: true,
  },
  {
    id: 158,
    name: 'addContactRolesSet',
    path: `${ROUTES.ADD_CONTACT_ROLES_SET}`,
    Component: addContactRolesSet,
    isPrivate: true,
  },
  {
    id: 159,
    name: 'addContactRolesLocation',
    path: `${ROUTES.ADD_CONTACT_ROLES_LOCATION}`,
    Component: addContactRolesLocation,
    isPrivate: true,
  },
  {
    id: 160,
    name: 'addContactRolesDepartment',
    path: `${ROUTES.ADD_CONTACT_ROLES_DEPARTMENT}`,
    Component: addContactRolesDepartment,
    isPrivate: true,
  },
  {
    id: 161,
    name: 'restrictedPermission',
    path: `${ROUTES.RESTRICTED_PERMISSION}`,
    Component: restrictedPermission,
    isPrivate: true,
  },
  {
    id: 162,
    name: 'studioDepartmentDetail',
    path: `${ROUTES.STUDIO_DEPARTMENT_DETAIL}/:id/:entityId`,
    Component: studioDepartmentDetail,
    isPrivate: true,
  },
  {
    id: 163,
    name: 'episodeDepartmentDetail',
    path: `${ROUTES.EPISODE_DEPARTMENT_DETAIL}/:module/:id/:entityId/:productionId`,
    Component: episodeDepartmentDetail,
    isPrivate: true,
  },
  {
    id: 164,
    name: 'setDepartmentDetail',
    path: `${ROUTES.SET_DEPARTMENT_DETAIL}/:module/:id/:entityId/:productionId`,
    Component: setDepartmentDetail,
    isPrivate: true,
  },
  {
    id: 165,
    name: 'locationDepartmentDetail',
    path: `${ROUTES.LOCATION_DEPARTMENT_DETAIL}/:module/:id/:entityId/:productionId`,
    Component: locationDepartmentDetail,
    isPrivate: true,
  },
  {
    id: 166,
    name: 'OrderWorksheet',
    path: `${ROUTES.ORDER_WORKSHEET}/:id`,
    Component: MyOrders,
    isPrivate: true,
    pageProp: { page: 'order-worksheet' },
  },
  {
    id: 167,
    name: 'financeAllOrders',
    path: `${ROUTES.FINANCE_ALL_ORDERS}`,
    Component: financeViewAllOrders,
    isPrivate: true,
  },
];

const pageRoutes = pageRoutess?.map((route: any, i: number) => {
  return {
    ...route,
    id: i,
  };
});

// console.log('pageRoutes', pageRoutes);

export { pageRoutes };
